document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.menu-toggle');
  const menu = document.querySelector('#MobileMenu');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      menu.hidden = !open;
      document.body.classList.toggle('menu-open', open);
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && !menu.hidden) {
        menu.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('menu-open');
        toggle.focus();
      }
    });
  }

  const reveal = root => {
    const items = root.querySelectorAll ? root.querySelectorAll('[data-hb-reveal], #MainContent > .shopify-section') : [];
    if (window.Shopify && window.Shopify.designMode) {
      items.forEach(item => item.classList.add('is-visible', 'visible'));
      return;
    }
    items.forEach(item => item.classList.add('hb-reveal-ready'));
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(item => item.classList.add('is-visible', 'visible'));
      return;
    }
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible', 'visible');
        observer.unobserve(entry.target);
      }
    }), { threshold: .12 });
    items.forEach(item => observer.observe(item));
  };
  reveal(document);
  document.addEventListener('shopify:section:load', event => reveal(event.target));
  document.addEventListener('shopify:section:select', event => {
    event.target.querySelectorAll('[data-hb-reveal]').forEach(item => item.classList.add('is-visible', 'visible'));
  });

  const initializeApprovedInteractions = root => {
    root.querySelectorAll('[data-product-gallery]').forEach(gallery => {
      gallery.querySelectorAll('[data-product-thumbnail]').forEach(button => {
        if (button.dataset.bound) return;
        button.dataset.bound = 'true';
        button.addEventListener('click', () => {
          gallery.querySelectorAll('[data-product-media]').forEach(media => {
            const active = media.id === button.dataset.target;
            media.hidden = !active;
            media.classList.toggle('is-active', active);
          });
          gallery.querySelectorAll('[data-product-thumbnail]').forEach(item => {
            const active = item === button;
            item.classList.toggle('is-active', active);
            item.setAttribute('aria-pressed', String(active));
          });
        });
      });
    });
    root.querySelectorAll('.approved-mock .fact button').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.setAttribute('aria-expanded', String(button.parentElement.classList.contains('open')));
      button.addEventListener('click', () => {
        const item = button.parentElement;
        const open = !item.classList.contains('open');
        item.classList.toggle('open', open);
        button.setAttribute('aria-expanded', String(open));
        const icon = button.querySelector('span');
        if (icon) icon.textContent = open ? '−' : '+';
      });
    });
    root.querySelectorAll('.approved-help .tab').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        button.closest('.tabs').querySelectorAll('.tab').forEach(item => item.classList.remove('active'));
        button.classList.add('active');
      });
    });
    root.querySelectorAll('.approved-contact .topic').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const card = button.closest('.form-card');
        card.querySelectorAll('.topic').forEach(item => item.classList.remove('active'));
        button.classList.add('active');
        const input = card.querySelector('[data-contact-topic]');
        if (input) input.value = button.dataset.topic || button.textContent.trim();
      });
    });
    root.querySelectorAll('.approved-make .option').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        button.closest('.options').querySelectorAll('.option').forEach(item => item.classList.remove('active'));
        button.classList.add('active');
      });
    });
    root.querySelectorAll('.approved-workshop .date').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        button.closest('.dates').querySelectorAll('.date').forEach(item => item.classList.remove('active'));
        button.classList.add('active');
      });
    });
    root.querySelectorAll('.approved-workshop .qty, .approved-event .qty').forEach(control => {
      if (control.dataset.bound) return;
      control.dataset.bound = 'true';
      const buttons = control.querySelectorAll('button');
      const output = control.querySelector('span');
      buttons.forEach((button, index) => button.addEventListener('click', () => {
        const current = Number(output.textContent) || 1;
        output.textContent = String(Math.max(1, current + (index === 0 ? -1 : 1)));
      }));
    });
  };
  initializeApprovedInteractions(document);
  document.addEventListener('shopify:section:load', event => initializeApprovedInteractions(event.target));
});
